/**
 * Mobile navigation — drawer toggle and keyboard support.
 *
 * @package DemocraticTools
 */

export function initNavigation() {
  const toggle = document.querySelector(".dt-nav-toggle");
  const panel = document.getElementById("dt-primary-nav-panel");
  const nav = document.querySelector(".dt-primary-nav");
  const searchToggle = document.querySelector(".dt-search-toggle");
  const searchPanel = document.getElementById("dt-header-search-panel");
  const searchClose = searchPanel?.querySelector(".dt-header-search__close");
  const searchInput = searchPanel?.querySelector('input[type="search"]');

  if (nav) {
    nav.setAttribute("role", "navigation");
    if (!nav.getAttribute("aria-label")) {
      nav.setAttribute("aria-label", "Primary");
    }
  }

  const setSearchOpen = (open) => {
    if (!searchToggle || !searchPanel) {
      return;
    }
    searchToggle.setAttribute("aria-expanded", open ? "true" : "false");
    searchPanel.hidden = !open;
    if (open) {
      searchInput?.focus();
    }
  };

  searchToggle?.addEventListener("click", () => {
    setSearchOpen(searchToggle.getAttribute("aria-expanded") !== "true");
  });
  searchClose?.addEventListener("click", () => {
    setSearchOpen(false);
    searchToggle?.focus();
  });

  document.addEventListener("keydown", (event) => {
    if (
      event.key === "Escape" &&
      searchToggle?.getAttribute("aria-expanded") === "true"
    ) {
      setSearchOpen(false);
      searchToggle.focus();
    }
  });

  if (!toggle || !panel) {
    return;
  }

  const setOpen = (open) => {
    toggle.setAttribute("aria-expanded", open ? "true" : "false");
    panel.hidden = !open;
  };

  toggle.addEventListener("click", () => {
    const isOpen = toggle.getAttribute("aria-expanded") === "true";
    setOpen(!isOpen);
  });

  document.addEventListener("keydown", (event) => {
    if (
      event.key === "Escape" &&
      toggle.getAttribute("aria-expanded") === "true"
    ) {
      setOpen(false);
      toggle.focus();
    }
  });

  window
    .matchMedia("(min-width: 64rem)")
    .addEventListener("change", (event) => {
      if (event.matches) {
        setOpen(true);
      }
    });
}
